import {enterProgress,statCountAt,infographicVisibleAt,INFOGRAPHIC_DEFAULT_SIZE,INFOGRAPHIC_DEFAULT_COLOR,INFOGRAPHIC_LAYOUT,infographicWideWidthFrac,infographicWideTextPx,infographicFontPx,infographicTitleBandMetrics,infographicBannerBurstMetrics,resolveInfographicSkin,glyphSparks,dropRetiredStyleInfographics,type InfographicItem} from '../infographics';
import {infoFontCss} from '../caption-fonts';
import {roundRect} from './cinematic-motion-draw';

export function drawInfographics(ctx: CanvasRenderingContext2D, items: InfographicItem[] | undefined, W: number, H: number, t: number,activeTitleFontId="default") {
  // 🧹 은퇴 마커 최종 방벽(적대 R1 P2) — 하이드레이트를 안 지나는 저장분(에이전트 code 잔존 등)의
  //   source:"style" 플레이스홀더를 여기서도 그리지 않는다(React 렌더러와 같은 소거 SSOT).
  const live = dropRetiredStyleInfographics(items);
  if (!live || !live.length) return;
  for (const it of live) {
    if (!infographicVisibleAt(it, t)) continue;
    const p = enterProgress(t, it.start ?? 0);
    if (p <= 0) continue;
    const color = it.color ?? INFOGRAPHIC_DEFAULT_COLOR;
    const fs = infographicFontPx(it.sizePct ?? INFOGRAPHIC_DEFAULT_SIZE[it.kind], H);
    const cx = it.x * W;
    const cy = it.y * H;
    ctx.save();
    ctx.globalAlpha = Math.min(1, Math.max(0, p) * 1.4);
    ctx.textAlign = "center";
    ctx.textBaseline = "middle";
    if (it.kind === "badge") {
      // 강조 배지 — 컬러 필 pop-in(스케일 오버슈트) + 흰 굵은 글씨.
      ctx.translate(cx, cy);
      ctx.scale(Math.max(0.01, p), Math.max(0.01, p));
      ctx.font = infoFontCss(activeTitleFontId, fs, 900);
      const w = ctx.measureText(it.text).width;
      const padX = fs * 0.6, padY = fs * 0.38;
      ctx.shadowColor = "rgba(0,0,0,0.35)"; ctx.shadowBlur = fs * 0.5; ctx.shadowOffsetY = fs * 0.12;
      ctx.fillStyle = color;
      roundRect(ctx, -w / 2 - padX, -fs / 2 - padY, w + padX * 2, fs + padY * 2, fs * 0.7);
      ctx.fill();
      ctx.shadowColor = "transparent"; ctx.shadowBlur = 0; ctx.shadowOffsetY = 0;
      ctx.fillStyle = "#fff";
      ctx.fillText(it.text, 0, fs * 0.04);
    } else if (it.kind === "price") {
      // 가격 카드 — 흰 카드 슬라이드업, 라벨(작게)+가격(크게·컬러)+원가(취소선 회색).
      const rise = (1 - p) * fs * 1.2;
      ctx.translate(cx, cy + rise);
      const priceText = String(it.value ?? "").trim() || it.text;
      const labelText = String(it.value ?? "").trim() ? it.text : "";
      ctx.font = infoFontCss(activeTitleFontId, Math.round(fs * 1.25), 900);
      const priceW = ctx.measureText(priceText).width;
      ctx.font = infoFontCss(activeTitleFontId, Math.round(fs * 0.62), 700);
      const labelW = labelText ? ctx.measureText(labelText).width : 0;
      const subW = it.sub ? ctx.measureText(it.sub).width : 0;
      const w = Math.max(priceW, labelW, subW) + fs * 1.4;
      const rows = 1 + (labelText ? 1 : 0) + (it.sub ? 1 : 0);
      const h = fs * (1.6 + rows * 0.9);
      ctx.shadowColor = "rgba(0,0,0,0.3)"; ctx.shadowBlur = fs * 0.6; ctx.shadowOffsetY = fs * 0.15;
      ctx.fillStyle = "#ffffff";
      roundRect(ctx, -w / 2, -h / 2, w, h, fs * 0.35);
      ctx.fill();
      ctx.shadowColor = "transparent"; ctx.shadowBlur = 0; ctx.shadowOffsetY = 0;
      let yy = -h / 2 + fs * 0.95;
      if (labelText) { ctx.font = infoFontCss(activeTitleFontId, Math.round(fs * 0.62), 700); ctx.fillStyle = "#666"; ctx.fillText(labelText, 0, yy); yy += fs * 0.85; }
      ctx.font = infoFontCss(activeTitleFontId, Math.round(fs * 1.25), 900); ctx.fillStyle = color; ctx.fillText(priceText, 0, yy + fs * 0.25); yy += fs * 1.3;
      if (it.sub) {
        ctx.font = infoFontCss(activeTitleFontId, Math.round(fs * 0.62), 700); ctx.fillStyle = "#9a9a9a";
        ctx.fillText(it.sub, 0, yy);
        const sw = ctx.measureText(it.sub).width;
        ctx.strokeStyle = "#9a9a9a"; ctx.lineWidth = Math.max(1.5, fs * 0.06);
        ctx.beginPath(); ctx.moveTo(-sw / 2, yy); ctx.lineTo(sw / 2, yy); ctx.stroke();
      }
    } else if (it.kind === "stat") {
      // 숫자 카운트업 — 큰 숫자(컬러·외곽 그림자)+접미사, 아래 라벨.
      const target = typeof it.value === "number" ? it.value : Number(String(it.value ?? "").replace(/[^\d.-]/g, "")) || 0;
      const now = statCountAt(t, target, it.start ?? 0);
      ctx.translate(cx, cy);
      ctx.scale(0.9 + 0.1 * p, 0.9 + 0.1 * p);
      ctx.shadowColor = "rgba(0,0,0,0.55)"; ctx.shadowBlur = fs * 0.35; ctx.shadowOffsetY = fs * 0.08;
      ctx.font = infoFontCss(activeTitleFontId, fs, 900);
      ctx.fillStyle = color;
      const numText = now.toLocaleString("ko-KR") + (it.sub ?? "");
      ctx.fillText(numText, 0, 0);
      ctx.shadowColor = "transparent"; ctx.shadowBlur = 0; ctx.shadowOffsetY = 0;
      ctx.font = infoFontCss(activeTitleFontId, Math.round(fs * 0.34), 800);
      ctx.fillStyle = "#ffffff";
      ctx.shadowColor = "rgba(0,0,0,0.65)"; ctx.shadowBlur = fs * 0.2;
      ctx.fillText(it.text, 0, fs * 0.78);
      ctx.shadowColor = "transparent"; ctx.shadowBlur = 0;
    } else if (it.kind === "list") {
      // 체크 리스트 — 반투명 카드에 불릿 줄 순차 등장(0.35s 스태거)·좌정렬.
      const items = it.items ?? [];
      ctx.font = infoFontCss(activeTitleFontId, fs, 800);
      const wMax = Math.max(it.text ? ctx.measureText(it.text).width : 0, ...items.map((li) => ctx.measureText(li).width + fs * 1.2), fs * 4);
      const lh = fs * 1.5;
      const rows = (it.text ? 1 : 0) + items.length;
      const w = wMax + fs * 1.4;
      const h = rows * lh + fs * 0.9;
      ctx.translate(cx, cy);
      ctx.shadowColor = "rgba(0,0,0,0.35)"; ctx.shadowBlur = fs * 0.5; ctx.shadowOffsetY = fs * 0.12;
      ctx.fillStyle = "rgba(17,17,17,0.82)";
      roundRect(ctx, -w / 2, -h / 2, w, h, fs * 0.45);
      ctx.fill();
      ctx.shadowColor = "transparent"; ctx.shadowBlur = 0; ctx.shadowOffsetY = 0;
      ctx.textAlign = "left";
      let yy = -h / 2 + fs * 0.45 + lh / 2;
      if (it.text) {
        ctx.font = infoFontCss(activeTitleFontId, fs, 900);
        ctx.fillStyle = color;
        ctx.fillText(it.text, -w / 2 + fs * 0.7, yy);
        yy += lh;
      }
      ctx.font = infoFontCss(activeTitleFontId, fs, 800);
      items.forEach((li, k) => {
        const lp = enterProgress(t, (it.start ?? 0) + 0.25 + k * 0.35); // 줄별 스태거 등장
        if (lp <= 0) { yy += lh; return; }
        ctx.globalAlpha = Math.min(1, Math.max(0, lp) * 1.4) * Math.min(1, Math.max(0, p) * 1.4);
        ctx.fillStyle = color;
        ctx.fillText("✓", -w / 2 + fs * 0.7, yy);
        ctx.fillStyle = "#fff";
        ctx.fillText(li, -w / 2 + fs * 0.7 + fs * 1.1, yy);
        yy += lh;
      });
    } else if (it.kind === "compare") {
      // 비교(VS) — 왼쪽(다크) vs 오른쪽(컬러) 필 + 중앙 VS. 양쪽이 바깥에서 슬라이드 인.
      ctx.font = infoFontCss(activeTitleFontId, fs, 900);
      const lw = ctx.measureText(it.text).width, rw = ctx.measureText(it.sub ?? "").width;
      const padX = fs * 0.55, padY = fs * 0.38, gap = fs * 1.7;
      const slide = (1 - p) * fs * 2.2;
      ctx.translate(cx, cy);
      ctx.shadowColor = "rgba(0,0,0,0.35)"; ctx.shadowBlur = fs * 0.4; ctx.shadowOffsetY = fs * 0.1;
      // 왼쪽 필(다크)
      ctx.fillStyle = "rgba(17,17,17,0.85)";
      roundRect(ctx, -gap / 2 - (lw + padX * 2) - slide, -fs / 2 - padY, lw + padX * 2, fs + padY * 2, fs * 0.5);
      ctx.fill();
      // 오른쪽 필(컬러)
      ctx.fillStyle = color;
      roundRect(ctx, gap / 2 + slide, -fs / 2 - padY, rw + padX * 2, fs + padY * 2, fs * 0.5);
      ctx.fill();
      ctx.shadowColor = "transparent"; ctx.shadowBlur = 0; ctx.shadowOffsetY = 0;
      ctx.fillStyle = "#fff";
      ctx.fillText(it.text, -gap / 2 - (lw + padX * 2) / 2 - padX / 2 - slide + padX / 2, fs * 0.04);
      ctx.fillText(it.sub ?? "", gap / 2 + (rw + padX * 2) / 2 + slide, fs * 0.04);
      ctx.font = infoFontCss(activeTitleFontId, Math.round(fs * 0.8), 900);
      ctx.fillStyle = "#F6C445";
      ctx.fillText("VS", 0, fs * 0.04);
    } else if (it.kind === "ring") {
      // 강조 링 — 도넛 호가 draw-in(진행도 각도) + 완성 후 미세 펄스. 라벨은 링 아래.
      const r = fs; // ring 은 sizePct=반경 비율
      const lwStroke = Math.max(3, r * 0.14);
      const pulse = p >= 1 ? 1 + 0.04 * Math.sin(t * 4.2) : 1;
      ctx.translate(cx, cy);
      ctx.strokeStyle = color;
      ctx.lineWidth = lwStroke;
      ctx.lineCap = "round";
      ctx.shadowColor = "rgba(0,0,0,0.45)"; ctx.shadowBlur = r * 0.25;
      ctx.beginPath();
      ctx.arc(0, 0, r * pulse, -Math.PI / 2, -Math.PI / 2 + Math.PI * 2 * Math.min(1, p), false);
      ctx.stroke();
      ctx.shadowColor = "transparent"; ctx.shadowBlur = 0;
      if (it.text) {
        ctx.font = infoFontCss(activeTitleFontId, Math.round(r * 0.34), 900);
        ctx.fillStyle = "#fff";
        ctx.shadowColor = "rgba(0,0,0,0.65)"; ctx.shadowBlur = r * 0.18;
        ctx.fillText(it.text, 0, r * pulse + r * 0.45);
        ctx.shadowColor = "transparent"; ctx.shadowBlur = 0;
      }
    } else if (it.kind === "bar") {
      // 게이지 바 — 라벨 + 트랙 위 채움(카운트 곡선) + 우측 % 숫자.
      const target = typeof it.value === "number" ? it.value : 0;
      const now = statCountAt(t, target, it.start ?? 0);
      const w = fs * 10, h = fs * 0.85;
      ctx.translate(cx, cy);
      ctx.font = infoFontCss(activeTitleFontId, fs, 800);
      ctx.fillStyle = "#fff";
      ctx.shadowColor = "rgba(0,0,0,0.6)"; ctx.shadowBlur = fs * 0.25;
      ctx.textAlign = "left";
      ctx.fillText(it.text, -w / 2, -h / 2 - fs * 0.75);
      ctx.shadowColor = "transparent"; ctx.shadowBlur = 0;
      ctx.fillStyle = "rgba(255,255,255,0.25)";
      roundRect(ctx, -w / 2, -h / 2, w, h, h / 2);
      ctx.fill();
      ctx.fillStyle = color;
      const fillW = Math.max(h, (now / 100) * w);
      roundRect(ctx, -w / 2, -h / 2, fillW, h, h / 2);
      ctx.fill();
      ctx.font = infoFontCss(activeTitleFontId, fs, 900);
      ctx.textAlign = "right";
      ctx.fillStyle = "#fff";
      ctx.shadowColor = "rgba(0,0,0,0.6)"; ctx.shadowBlur = fs * 0.25;
      ctx.fillText(`${now}%`, w / 2, -h / 2 - fs * 0.75);
      ctx.shadowColor = "transparent"; ctx.shadowBlur = 0;
    } else if (it.kind === "panelCard") {
      // 📋 문제판 패널 — 스킨 배경 + 포인트 테두리(+글로우) 위에 제목/본문. 팝인(스케일)+살짝 상승.
      const sk = resolveInfographicSkin(it);
      const body = it.items?.length ? it.items : it.sub ? [it.sub] : [];
      // 📐 폭·여백·반경은 양 렌더러 공용 규칙(INFOGRAPHIC_LAYOUT)에서만 읽는다 — React 쪽과 숫자가
      //    갈라지면 같은 아이템이 미리보기와 렌더에서 다른 폭으로 뜬다(Codex 1R P2-6).
      const L = INFOGRAPHIC_LAYOUT.panelCard;
      const titleFs = Math.round(fs * L.titleEm);
      ctx.font = infoFontCss(activeTitleFontId, titleFs, sk.weight);
      const titleW = ctx.measureText(it.text).width;
      ctx.font = infoFontCss(activeTitleFontId, fs, Math.max(700, sk.weight - 100));
      const bodyW = body.reduce((m, li) => Math.max(m, ctx.measureText(li).width), 0);
      const w = Math.max(titleW, bodyW, fs * L.minTextEm) + fs * L.padXEm * 2;
      const lh = fs * L.lineEm;
      const h = titleFs * 1.6 + body.length * lh + fs * L.padYEm * 2;
      ctx.translate(cx, cy + (1 - Math.min(1, p)) * fs * 0.6);
      ctx.scale(Math.max(0.01, 0.94 + 0.06 * p), Math.max(0.01, 0.94 + 0.06 * p));
      if (sk.glow > 0) { ctx.shadowColor = sk.accent; ctx.shadowBlur = fs * sk.glow * 2.2; }
      ctx.fillStyle = sk.bg;
      roundRect(ctx, -w / 2, -h / 2, w, h, fs * L.radiusEm);
      ctx.fill();
      if (sk.border > 0) {
        ctx.strokeStyle = sk.accent;
        ctx.lineWidth = Math.max(1.5, fs * sk.border * 2);
        roundRect(ctx, -w / 2, -h / 2, w, h, fs * L.radiusEm);
        ctx.stroke();
      }
      ctx.shadowColor = "transparent"; ctx.shadowBlur = 0;
      let yy = -h / 2 + fs * L.padYEm + titleFs * 0.8;
      ctx.font = infoFontCss(activeTitleFontId, titleFs, sk.weight);
      ctx.fillStyle = sk.accent;
      ctx.fillText(it.text, 0, yy);
      yy += titleFs * 0.8 + lh * 0.75;
      ctx.font = infoFontCss(activeTitleFontId, fs, Math.max(700, sk.weight - 100));
      ctx.fillStyle = sk.fg;
      body.forEach((li, k) => {
        // 본문은 줄별 스태거(리스트와 같은 관용구) — 문제 문장이 한 박자씩 눈에 들어온다.
        const lp = enterProgress(t, (it.start ?? 0) + 0.2 + k * 0.28);
        if (lp <= 0) { yy += lh; return; }
        ctx.globalAlpha = Math.min(1, Math.max(0, lp) * 1.4) * Math.min(1, Math.max(0, p) * 1.4);
        ctx.fillText(li, 0, yy);
        yy += lh;
      });
    } else if (it.kind === "glyphReveal") {
      // ⭕ 대형 글리프 리빌 — 미끄러져 들어오지 않고 한 번에 팝으로 터진다(화이트 플래시 + 방사 스파크).
      //   ★파티클은 결정론(glyphSparks 시드 해시) — 프레임마다 난수를 뽑으면 불티가 순간이동한다.
      const sk = resolveInfographicSkin(it);
      const tRel = t - (it.start ?? 0);
      if (sk.flash > 0 && tRel >= 0 && tRel < 0.12) {
        // 1~2프레임 화이트 플래시(스킨 옵션) — 화면 전체를 아주 짧게 띄운다.
        ctx.save();
        ctx.globalAlpha = sk.flash * (1 - tRel / 0.12);
        ctx.fillStyle = "#ffffff";
        ctx.fillRect(0, 0, W, H);
        ctx.restore();
      }
      const q = Math.max(0, Math.min(1, tRel / 0.7)); // 불티 비행 진행도
      const fly = 1 - Math.pow(1 - q, 2.4); // ease-out
      ctx.translate(cx, cy);
      if (q < 1) {
        ctx.save();
        ctx.globalAlpha = Math.min(1, ctx.globalAlpha) * (1 - q);
        ctx.fillStyle = sk.accent;
        for (const s of glyphSparks()) {
          const d = s.dist * fs * fly;
          const r = Math.max(1, s.size * fs * (1 - q * 0.6));
          ctx.beginPath();
          ctx.arc(Math.cos(s.angle) * d, Math.sin(s.angle) * d, r, 0, Math.PI * 2);
          ctx.fill();
        }
        ctx.restore();
      }
      ctx.scale(Math.max(0.01, p), Math.max(0.01, p));
      ctx.font = infoFontCss(activeTitleFontId, fs, sk.weight);
      if (sk.glow > 0) { ctx.shadowColor = sk.accent; ctx.shadowBlur = fs * sk.glow; }
      ctx.strokeStyle = sk.accent;
      ctx.lineWidth = Math.max(2, fs * sk.border * 0.5);
      ctx.strokeText(it.text, 0, fs * 0.04);
      ctx.fillStyle = sk.fg;
      ctx.fillText(it.text, 0, fs * 0.04);
      ctx.shadowColor = "transparent"; ctx.shadowBlur = 0;
    } else if (it.kind === "bannerBurst") {
      // 💥 하단 풀와이드 톱니 배너 — 가운데에서 가로로 터져 나오고 굵은 카피가 박힌다(1~2줄).
      const sk = resolveInfographicSkin(it);
      const lines = [it.text, ...(it.sub ? [it.sub] : [])];
      // 📐 몸통·톱니·글로우는 배너 기하 SSOT 한 곳에서만 온다(#1885 — 배치판 경고도 같은 함수를 읽는다).
      const banner = infographicBannerBurstMetrics(lines.length, sk.glow);
      const bw = W * infographicWideWidthFrac("bannerBurst", W, H);
      const bh = fs * banner.bodyHeightEm;
      const teeth = 22;
      const tooth = fs * banner.toothEm;
      // ★풀와이드라 x 는 무시하고 화면 가로 중앙에 고정한다(y 만 위치 축). 도형만 가로 스케일로 터뜨리고
      //   글자는 스케일 밖에서 그린다 — 안 그러면 등장 중에 글씨가 가로로 찌그러진다.
      ctx.save();
      ctx.translate(W / 2, cy);
      ctx.scale(Math.max(0.01, Math.min(1, p)), 1); // 가로로 터져 나온다
      if (sk.glow > 0) { ctx.shadowColor = sk.accent; ctx.shadowBlur = fs * banner.glowBlurEm; }
      ctx.fillStyle = sk.accent;
      ctx.beginPath();
      ctx.moveTo(-bw / 2, -bh / 2);
      for (let k = 0; k < teeth; k++) {
        const x0 = -bw / 2 + (bw * k) / teeth;
        const x1 = -bw / 2 + (bw * (k + 0.5)) / teeth;
        ctx.lineTo(x1, -bh / 2 - tooth);
        ctx.lineTo(x0 + bw / teeth, -bh / 2);
      }
      for (let k = 0; k < teeth; k++) {
        const x0 = bw / 2 - (bw * k) / teeth;
        const x1 = bw / 2 - (bw * (k + 0.5)) / teeth;
        ctx.lineTo(x0, bh / 2);
        ctx.lineTo(x1, bh / 2 + tooth);
      }
      ctx.lineTo(-bw / 2, bh / 2);
      ctx.closePath();
      ctx.fill();
      ctx.shadowColor = "transparent"; ctx.shadowBlur = 0;
      // 안쪽 어두운 판(글자 가독성) — paper 스킨처럼 배경이 밝으면 그대로 대비가 선다.
      ctx.fillStyle = sk.bg;
      roundRect(ctx, -bw / 2 + fs * 0.35, -bh / 2 + fs * 0.28, bw - fs * 0.7, bh - fs * 0.56, fs * 0.25);
      ctx.fill();
      ctx.restore(); // 가로 스케일 해제 — 여기부터는 아이템 기준 좌표계(외부 변환은 그대로 보존)
      ctx.globalAlpha = Math.min(1, Math.max(0, p) * 1.4) * Math.max(0, Math.min(1, (p - 0.25) / 0.5));
      // 📐 글자만 안쪽 폭에 맞춰 줄인다(3-b · Remotion 과 같은 함수) — 줄 간격·몸통은 원래 크기 기준.
      ctx.font = infoFontCss(activeTitleFontId, infographicWideTextPx("bannerBurst", fs, lines, bw), sk.weight);
      ctx.fillStyle = sk.fg;
      const startY = cy - ((lines.length - 1) * fs * 1.25) / 2;
      lines.forEach((li, k) => ctx.fillText(li, W / 2, startY + k * fs * 1.25));
    } else if (it.kind === "titleBand") {
      // 🎫 상단 타이틀 밴드 — 뱃지(sub) + 카피(text, \n 최대 2줄). 위에서 내려와 안착.
      //   ★기존 drawTitleBand(reedit 프레임 전용 상단 제목 띠)는 그대로 둔다 — 저쪽은 프레임 고정 장식이고
      //     이쪽은 아이템 스펙(위치·표시창·스킨)을 갖는 오버레이라, 룩만 같은 계열이지 소비처가 다르다.
      const sk = resolveInfographicSkin(it);
      const lines = it.text.split("\n").filter(Boolean).slice(0, 2);
      const badge = (it.sub ?? "").trim();
      // 📐 카피 글자는 밴드 최대 폭에 맞춰 줄인다(3-b · Remotion 과 같은 함수) — 높이·패딩·뱃지는 원래 크기 기준.
      const textFs = infographicWideTextPx("titleBand", fs, lines, W * infographicWideWidthFrac("titleBand", W, H));
      ctx.font = infoFontCss(activeTitleFontId, textFs, sk.weight);
      const copyW = lines.reduce((m, li) => Math.max(m, ctx.measureText(li).width), 0);
      // 📐 높이·뱃지 위치뿐 아니라 글로우·테두리도 밴드 기하 SSOT 한 곳에서만 온다(배치판 경고도 같은 상수를 읽는다).
      const titleMetrics = infographicTitleBandMetrics(fs, lines.length, Boolean(badge), sk);
      const badgeFs = titleMetrics.badgeFontPx;
      ctx.font = infoFontCss(activeTitleFontId, badgeFs, sk.weight);
      const badgeW = badge ? ctx.measureText(badge).width + badgeFs * 1.3 : 0;
      const w = Math.min(W * infographicWideWidthFrac("titleBand", W, H), Math.max(copyW, badgeW, fs * INFOGRAPHIC_LAYOUT.titleBand.minTextEm) + fs * 2.4);
      const h = titleMetrics.heightPx;
      ctx.translate(cx, cy - (1 - Math.min(1, p)) * h);
      if (titleMetrics.glowBlurPx > 0) { ctx.shadowColor = sk.accent; ctx.shadowBlur = titleMetrics.glowBlurPx; }
      ctx.fillStyle = sk.bg;
      roundRect(ctx, -w / 2, -h / 2, w, h, fs * 0.45);
      ctx.fill();
      ctx.shadowColor = "transparent"; ctx.shadowBlur = 0;
      if (titleMetrics.borderWidthPx > 0) {
        ctx.strokeStyle = sk.accent;
        // ★stroke 는 경로에 중심을 둔다★ — 선 두께의 절반이 몸통 밖으로 나가고, 그게 배치판 경고가 재는 하단이다.
        ctx.lineWidth = titleMetrics.borderWidthPx;
        roundRect(ctx, -w / 2, -h / 2, w, h, fs * 0.45);
        ctx.stroke();
      }
      if (badge && titleMetrics.badgeCenterY != null) {
        ctx.font = infoFontCss(activeTitleFontId, badgeFs, sk.weight);
        const bwid = ctx.measureText(badge).width + badgeFs * 1.2;
        ctx.fillStyle = sk.accent;
        roundRect(ctx, -bwid / 2, titleMetrics.badgeCenterY - badgeFs * 0.72, bwid, badgeFs * 1.44, badgeFs * 0.72);
        ctx.fill();
        ctx.fillStyle = sk.bg;
        ctx.fillText(badge, 0, titleMetrics.badgeCenterY + titleMetrics.badgeTextOffsetY);
      }
      ctx.font = infoFontCss(activeTitleFontId, textFs, sk.weight);
      ctx.fillStyle = sk.fg;
      lines.forEach((li, index) => ctx.fillText(li, 0, titleMetrics.titleCenterYs[index]));
    } else {
      // arrow — 라벨 필 + 팁으로 뻗는 화살표(진행도만큼 draw-in).
      const tip = it.tip ?? { x: Math.min(1, it.x + 0.12), y: Math.min(1, it.y + 0.14) };
      const tx = tip.x * W, ty = tip.y * H;
      ctx.font = infoFontCss(activeTitleFontId, fs, 900);
      const w = ctx.measureText(it.text).width;
      const padX = fs * 0.5, padY = fs * 0.32;
      ctx.shadowColor = "rgba(0,0,0,0.35)"; ctx.shadowBlur = fs * 0.4; ctx.shadowOffsetY = fs * 0.1;
      ctx.fillStyle = "rgba(17,17,17,0.85)";
      roundRect(ctx, cx - w / 2 - padX, cy - fs / 2 - padY, w + padX * 2, fs + padY * 2, fs * 0.4);
      ctx.fill();
      ctx.shadowColor = "transparent"; ctx.shadowBlur = 0; ctx.shadowOffsetY = 0;
      ctx.fillStyle = "#fff";
      ctx.fillText(it.text, cx, cy + fs * 0.04);
      // 화살선 — 필 가장자리에서 팁까지, p 비율로 draw-in + 화살촉.
      const startX = cx + (tx >= cx ? 1 : -1) * (w / 2 + padX);
      const startY = cy + (ty >= cy ? 1 : -1) * (fs / 2 + padY) * 0.6;
      const ex = startX + (tx - startX) * p;
      const ey = startY + (ty - startY) * p;
      ctx.strokeStyle = color; ctx.lineWidth = Math.max(2.5, fs * 0.14); ctx.lineCap = "round";
      ctx.beginPath(); ctx.moveTo(startX, startY); ctx.lineTo(ex, ey); ctx.stroke();
      if (p > 0.85) {
        const ang = Math.atan2(ey - startY, ex - startX);
        const ah = Math.max(6, fs * 0.42);
        ctx.fillStyle = color;
        ctx.beginPath();
        ctx.moveTo(ex, ey);
        ctx.lineTo(ex - ah * Math.cos(ang - 0.45), ey - ah * Math.sin(ang - 0.45));
        ctx.lineTo(ex - ah * Math.cos(ang + 0.45), ey - ah * Math.sin(ang + 0.45));
        ctx.closePath(); ctx.fill();
      }
    }
    ctx.restore();
  }
}
